import React from 'react';
import { ExternalLink, Info, ShoppingBag, Sparkles, Star, Zap } from 'lucide-react';

const AFFILIATE_TAG = 'fitness330a-20';

const makeAmazonSearchUrl = (query) =>
  `https://www.amazon.com/s?k=${encodeURIComponent(query).replace(/%20/g, '+')}&tag=${AFFILIATE_TAG}`;

const snacks = [
  {
    name: 'David Protein Gold Bars',
    query: 'David Protein Gold Bars 28g Protein',
    protein: '28g',
    calories: '150',
    carbs: '8g',
    fat: '2.5g',
    sugar: '0g',
    serving: '1 bar',
    category: 'Protein Bar',
    description: 'One of the strongest protein-to-calorie ratios in the bar category, built for people who need a lot of protein without spending many calories.',
    imageUrl: 'https://davidprotein.com/cdn/shop/files/CCCD_WrapperNFP.png?format=webp&v=1777506959&width=480',
    accent: 'from-amber-300 via-yellow-200 to-stone-100',
    badge: 'Best Macro Ratio',
    featured: true,
  },
  {
    name: 'Quest Tortilla Protein Chips',
    query: 'Quest Tortilla Protein Chips Nacho Cheese 18g Protein',
    protein: '18g',
    calories: '140',
    carbs: '5g',
    fat: '4.5g',
    sugar: '1g',
    serving: '1 bag',
    category: 'Protein Chips',
    description: 'A crunchy chip-style snack that fits better than regular chips when protein is the priority.',
    imageUrl: 'https://www.questnutrition.com/cdn/shop/files/qst-010295-nacho-cheese-tortilla-style-protein-chips_2.png?v=1771629330&width=900',
    accent: 'from-orange-400 via-yellow-300 to-orange-100',
    badge: 'Crunch Pick',
    featured: true,
  },
  {
    name: 'Legendary Foods Protein Chips',
    query: 'Legendary Foods Protein Chips 20g Protein',
    protein: '20g',
    calories: '150',
    carbs: '4g',
    fat: '5g',
    sugar: '1g',
    serving: '1 bag',
    category: 'Protein Chips',
    description: 'A savory option for high-protein snackers who want chips instead of another bar.',
    imageUrl: 'https://www.eatlegendary.com/cdn/shop/files/Nacho-Cheese_Hero__Egg.webp?v=1776102221&width=900',
    accent: 'from-red-400 via-orange-300 to-amber-100',
    badge: '20g Protein',
    featured: true,
  },
  {
    name: 'Barebells Protein Bars',
    query: 'Barebells Protein Bars 20g Protein',
    protein: '20g',
    calories: '200-210',
    carbs: '20g',
    fat: '7-8g',
    sugar: '1-2g',
    serving: '1 bar',
    category: 'Protein Bar',
    description: 'Dessert-style protein bars with strong taste, no added sugar, and reliable 20g protein servings.',
    imageUrl: 'https://shop.barebells.com/cdn/shop/files/barebells_peanut_butter_gallery_eomm1vnv.png?v=1774611478&width=900',
    accent: 'from-sky-300 via-orange-200 to-yellow-100',
    badge: 'Taste Pick',
    featured: true,
  },
  {
    name: 'Legendary Foods Protein Pastry',
    query: 'Legendary Foods Protein Pastry 20g Protein',
    protein: '20g',
    calories: '180',
    carbs: '24g',
    fat: '8g',
    sugar: '1g',
    serving: '1 pastry',
    category: 'Protein Pastry',
    description: 'A sweet pastry-style option with high protein, low sugar, and a more treat-like feel than most bars.',
    imageUrl: 'https://www.eatlegendary.com/cdn/shop/files/PASTRY_STRAWBERRY__STATIC___A.0.0.webp?v=1767731017&width=900',
    accent: 'from-pink-300 via-rose-200 to-white',
    badge: 'Sweet Pick',
    featured: true,
  },
  {
    name: 'Stryve Beef Biltong',
    query: 'Stryve Beef Biltong High Protein',
    protein: '16g',
    calories: '90',
    carbs: '0g',
    fat: '2g',
    sugar: '0g',
    serving: '1 oz',
    category: 'Meat Snack',
    description: 'Lean dried beef with very strong protein per calorie and almost no carbs.',
    imageUrl: 'https://www.kroger.com/product/images/large/front/0085649200746',
    accent: 'from-red-700 via-red-500 to-orange-200',
    badge: 'Lean Pick',
    featured: true,
  },
  {
    name: 'StarKist Tuna Creations Pouches',
    query: 'StarKist Tuna Creations Pouches Protein',
    protein: '15-17g',
    calories: '70-110',
    carbs: '0-3g',
    fat: '0.5-3g',
    sugar: '0g',
    serving: '1 pouch',
    category: 'Seafood',
    description: 'Shelf-stable tuna pouches with excellent protein density for low-calorie days.',
    imageUrl: 'https://starkist.com/wp-content/uploads/2014/11/847508213-813791-01_sk_clw_2-6oz_p495240po-7_f.webp',
    accent: 'from-blue-500 via-cyan-300 to-slate-100',
    badge: 'Leanest',
    featured: true,
  },
  {
    name: 'Wilde Protein Chips',
    query: 'Wilde Protein Chips',
    protein: '10-14g',
    calories: '170',
    carbs: '8-10g',
    fat: '10g',
    sugar: '1g',
    serving: '1 bag',
    category: 'Protein Chips',
    description: 'Chicken-based chips for people who want something crunchy, salty, and more filling than standard chips.',
    imageUrl: 'https://www.wildebrands.com/cdn/shop/files/Wilde_4oz_Buffalo_Render.png?v=1764706842&width=900',
    accent: 'from-lime-300 via-yellow-200 to-orange-100',
  },
  {
    name: 'Whisps Cheese Crisps',
    query: 'Whisps Cheese Crisps 12g Protein',
    protein: '12g',
    calories: '150',
    carbs: '1g',
    fat: '11g',
    sugar: '0g',
    serving: '1 serving',
    category: 'Low Carb',
    description: 'Cheese crisps that work well for low-carb snackers who still want crunch.',
    imageUrl: 'https://whisps.com/wp-content/uploads/2025/03/Whisps_2.12oz_Cheddar_088231413202_FRONT_2365x2365.png',
    accent: 'from-yellow-300 via-amber-200 to-white',
  },
  {
    name: 'Quest Protein Bars',
    query: 'Quest Protein Bars Chocolate Chip Cookie Dough',
    protein: '20-21g',
    calories: '180-200',
    carbs: '21g',
    fat: '7-9g',
    sugar: '1g',
    serving: '1 bar',
    category: 'Protein Bar',
    description: 'A staple high-protein bar with many flavors and a macro profile that is easy to plan around.',
    imageUrl: 'https://www.questnutrition.com/cdn/shop/files/qst-003853-chocolate-chip-cookie-dough-protein-bars_1.png?v=1772649648&width=900',
    accent: 'from-blue-400 via-sky-200 to-white',
  },
  {
    name: 'ONE Protein Bars',
    query: 'ONE Protein Bars 20g Protein',
    protein: '20g',
    calories: '210-230',
    carbs: '22g',
    fat: '7-9g',
    sugar: '1g',
    serving: '1 bar',
    category: 'Protein Bar',
    description: 'A dessert-flavored bar line for users who want protein with candy-bar style flavors.',
    imageUrl: 'https://s7d1.scene7.com/is/image/hersheyprodcloud/7_88434_10808_9_776_10810_010_CND_Item_Front?fmt=webp-alpha&hei=908&qlt=75',
    accent: 'from-purple-400 via-pink-200 to-white',
  },
  {
    name: 'Pure Protein Bars',
    query: 'Pure Protein Bars 20g Protein',
    protein: '20g',
    calories: '180-200',
    carbs: '17g',
    fat: '4.5-7g',
    sugar: '2g',
    serving: '1 bar',
    category: 'Protein Bar',
    description: 'A budget-friendly protein bar option with solid protein for the calories.',
    imageUrl: 'https://www.pureprotein.com/cdn/shop/files/749826138879_A1C1.jpg?v=1741881392&width=900',
    accent: 'from-indigo-400 via-blue-200 to-white',
  },
  {
    name: 'Think! High Protein Bars',
    query: 'Think High Protein Bars 20g Protein',
    protein: '20g',
    calories: '230',
    carbs: '23g',
    fat: '8g',
    sugar: '0g',
    serving: '1 bar',
    category: 'Protein Bar',
    description: 'A straightforward protein bar for users who want a familiar, easy-to-find snack.',
    imageUrl: 'https://www.thinkproducts.com/cdn/shop/files/tkp-701417-high-protein-bar-chocolate-fudge_1.png?v=1779482594&width=900',
    accent: 'from-stone-500 via-stone-300 to-white',
  },
  {
    name: 'No Cow Protein Bars',
    query: 'No Cow Protein Bars 20g Protein',
    protein: '20g+',
    calories: '190-210',
    carbs: '23-26g',
    fat: '5-6g',
    sugar: '1g',
    serving: '1 bar',
    category: 'Plant Based',
    description: 'A plant-based protein bar for dairy-free users who still want serious protein.',
    imageUrl: 'https://nocow.com/cdn/shop/files/Chocolate_Chip_Cookie_Dough_Performance_Bar_Product_Render_New.png?v=1776195348&width=900',
    accent: 'from-emerald-400 via-lime-200 to-white',
  },
  {
    name: 'FITCRUNCH Protein Bars',
    query: 'FITCRUNCH Protein Bars',
    protein: '16-30g',
    calories: '190-380',
    carbs: '14-27g',
    fat: '8-16g',
    sugar: '3-6g',
    serving: '1 bar',
    category: 'Protein Bar',
    description: 'A richer, layered protein bar that can work as a higher-calorie snack or small meal bridge.',
    imageUrl: 'https://i5.walmartimages.com/seo/Chef-Robert-Irvine-s-Fit-Crunch-Chocolate-Peanut-Butter-Whey-Protein-Bars-18-count-1-62oz_ea62b652-911b-498a-bee5-250c5ad3e595.88e70544233bc598d29644fcb1d24404.jpeg',
    accent: 'from-red-500 via-yellow-300 to-white',
  },
  {
    name: 'Kirkland Signature Protein Bars',
    query: 'Kirkland Signature Protein Bars 21g Protein',
    protein: '21g',
    calories: '190',
    carbs: '22g',
    fat: '7g',
    sugar: '2g',
    serving: '1 bar',
    category: 'Protein Bar',
    description: 'A strong value option with competitive protein per calorie for bulk buyers.',
    imageUrl: 'https://bfasset.costco-static.com/U447IH35/as/xqwtqjf3kzkhh32cn38pbnvk/1168029-847__1?auto=webp&canvas=1024%2C1024&fit=bounds&format=jpg&height=1024&width=1024',
    accent: 'from-red-600 via-white to-blue-200',
  },
  {
    name: 'Power Crunch Protein Wafer Bars',
    query: 'Power Crunch Protein Wafer Bars',
    protein: '13-14g',
    calories: '205-220',
    carbs: '10-12g',
    fat: '13-15g',
    sugar: '5g',
    serving: '1 wafer',
    category: 'Protein Bar',
    description: 'A lighter, crisp wafer texture for users who dislike dense protein bars.',
    imageUrl: 'https://powercrunch.com/cdn/shop/files/PCO_Vanilla_Creme_LS1.jpg?v=1778004044&width=900',
    accent: 'from-cyan-300 via-blue-100 to-white',
  },
  {
    name: 'Chomps Meat Sticks',
    query: 'Chomps Meat Sticks Protein',
    protein: '10g',
    calories: '90-100',
    carbs: '0g',
    fat: '6g',
    sugar: '0g',
    serving: '1 stick',
    category: 'Meat Snack',
    description: 'Portable meat sticks that are simple, low-carb, and easy to keep in a bag.',
    imageUrl: 'https://www.kroger.com/product/images/large/front/0085658400418',
    accent: 'from-orange-700 via-orange-400 to-yellow-100',
  },
  {
    name: "Jack Link's Beef Jerky",
    query: 'Jack Links Beef Jerky 10g Protein',
    protein: '10g',
    calories: '80',
    carbs: '5g',
    fat: '1g',
    sugar: '4g',
    serving: '1 oz',
    category: 'Meat Snack',
    description: 'Classic jerky with solid protein and a familiar flavor profile.',
    imageUrl: 'https://www.jacklinks.com/shop/pub/media/catalog/product/1/0/10000018005_3.25oz_jl_bf_orig_jerk_hero.png',
    accent: 'from-red-800 via-red-500 to-amber-100',
  },
  {
    name: 'EPIC Protein Bars',
    query: 'EPIC Protein Bars Jerky',
    protein: '11-15g',
    calories: '120-170',
    carbs: '1-7g',
    fat: '6-10g',
    sugar: '0-3g',
    serving: '1 bar',
    category: 'Meat Snack',
    description: 'A meat-based bar option for users who want protein without a sweet protein-bar taste.',
    imageUrl: 'https://epicprovisions.com/cdn/shop/products/BeefSeaSaltPepperBarCaddy_1200x1200.png?v=1682351805&width=900',
    accent: 'from-neutral-700 via-stone-400 to-orange-100',
  },
  {
    name: 'Bumble Bee Tuna Pouches',
    query: 'Bumble Bee Tuna Pouches 14g Protein',
    protein: '14g',
    calories: '70',
    carbs: '0g',
    fat: '1g',
    sugar: '0g',
    serving: '1 pouch',
    category: 'Seafood',
    description: 'A lean, shelf-stable protein pouch that works especially well for low-calorie tracking days.',
    imageUrl: 'https://i0.wp.com/www.bumblebee.com/wp-content/uploads/2020/08/Bumble-Bee%C2%AE-Wild-Caught-Albacore-Tuna-in-Water-Pouch.png?fit=760%2C608&ssl=1',
    accent: 'from-sky-600 via-blue-300 to-white',
  },
];

const ProductVisual = ({ snack }) => (
  <div className={`relative flex h-48 items-center justify-center overflow-hidden rounded-lg bg-gradient-to-br ${snack.accent}`}>
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(255,255,255,0.75),transparent_32%),radial-gradient(circle_at_80%_30%,rgba(255,255,255,0.35),transparent_25%)]" />
    <img
      src={snack.imageUrl}
      alt={`${snack.name} product packaging`}
      loading="lazy"
      className="relative z-10 h-full max-h-44 w-full object-contain p-4 drop-shadow-xl"
      onError={(event) => {
        event.currentTarget.style.display = 'none';
        event.currentTarget.nextElementSibling?.classList.remove('hidden');
      }}
    />
    <div className="relative z-10 hidden w-44 rounded-md border border-white/70 bg-white/90 p-3 shadow-xl">
      <div className="text-sm font-black leading-tight text-gray-950">{snack.name}</div>
      <div className="mt-3 text-xs font-bold text-gray-700">{snack.protein} protein</div>
    </div>
    <div className="absolute left-3 top-3 z-20 rounded-full bg-white/90 px-2.5 py-1 text-[11px] font-black text-gray-900 shadow-sm">
      {snack.protein} protein
    </div>
    <div className="absolute bottom-3 right-3 z-20 rounded-full bg-gray-900/90 px-2.5 py-1 text-[11px] font-black text-white shadow-sm">
      {snack.calories} cal
    </div>
  </div>
);

const NutritionFact = ({ label, value }) => (
  <div className="rounded-md bg-gray-50 px-2.5 py-2 dark:bg-gray-900/70">
    <div className="text-[10px] font-bold uppercase tracking-wide text-gray-400">{label}</div>
    <div className="mt-0.5 text-sm font-extrabold text-gray-900 dark:text-white">{value}</div>
  </div>
);

const MacroSnacks = () => {
  const featuredSnacks = snacks.filter((snack) => snack.featured);

  return (
    <div className="max-w-7xl mx-auto p-4 sm:p-6 space-y-6">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300">
            <Zap className="h-3.5 w-3.5" />
            High Macro Finds
          </div>
          <h1 className="mt-3 text-2xl font-extrabold text-gray-900 dark:text-white sm:text-3xl">
            Amazon Macro Snacks
          </h1>
          <p className="mt-2 max-w-3xl text-sm leading-6 text-gray-500 dark:text-gray-400">
            Protein-forward snacks that are easier to fit into a tracking day. Nutrition facts are approximate and can vary by flavor, so check the Amazon listing and package label before ordering.
          </p>
        </div>
        <a
          href={makeAmazonSearchUrl('high protein snacks')}
          target="_blank"
          rel="noopener noreferrer sponsored"
          className="inline-flex items-center justify-center gap-2 rounded-lg bg-gray-900 px-4 py-2.5 text-sm font-semibold text-white hover:bg-gray-800 dark:bg-white dark:text-gray-900 dark:hover:bg-gray-100"
        >
          <ShoppingBag className="h-4 w-4" />
          Browse Amazon
          <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>

      <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-xs leading-5 text-amber-900 dark:border-amber-900/60 dark:bg-amber-950/30 dark:text-amber-200">
        <div className="flex gap-2">
          <Info className="mt-0.5 h-4 w-4 flex-shrink-0" />
          <p>
            As an Amazon Associate, we may earn from qualifying purchases. Links use Amazon search pages with the affiliate tag attached so they stay useful even when individual listings change.
          </p>
        </div>
      </div>

      <section>
        <div className="mb-3 flex items-center gap-2">
          <Sparkles className="h-4 w-4 text-emerald-600" />
          <h2 className="text-sm font-extrabold uppercase tracking-wide text-gray-700 dark:text-gray-300">Top Picks</h2>
        </div>
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {featuredSnacks.map((snack) => (
            <article key={snack.name} className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800">
              <ProductVisual snack={snack} />
              <div className="space-y-4 p-4">
                <div>
                  <div className="mb-2 inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-1 text-[11px] font-bold text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300">
                    <Star className="h-3 w-3 fill-current" />
                    {snack.badge}
                  </div>
                  <h3 className="text-lg font-extrabold text-gray-900 dark:text-white">{snack.name}</h3>
                  <p className="mt-2 text-sm leading-6 text-gray-500 dark:text-gray-400">{snack.description}</p>
                </div>
                <div className="grid grid-cols-5 gap-2">
                  <NutritionFact label="Protein" value={snack.protein} />
                  <NutritionFact label="Calories" value={snack.calories} />
                  <NutritionFact label="Carbs" value={snack.carbs} />
                  <NutritionFact label="Fat" value={snack.fat} />
                  <NutritionFact label="Sugar" value={snack.sugar} />
                </div>
                <a
                  href={makeAmazonSearchUrl(snack.query)}
                  target="_blank"
                  rel="noopener noreferrer sponsored"
                  className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-bold text-white hover:bg-indigo-700"
                >
                  Shop on Amazon
                  <ExternalLink className="h-4 w-4" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section>
        <div className="mb-3 flex items-center gap-2">
          <ShoppingBag className="h-4 w-4 text-indigo-600" />
          <h2 className="text-sm font-extrabold uppercase tracking-wide text-gray-700 dark:text-gray-300">All Macro Snacks</h2>
        </div>
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {snacks.map((snack) => (
            <article key={snack.name} className="flex flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800">
              <ProductVisual snack={snack} />
              <div className="flex flex-1 flex-col p-4">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <p className="text-xs font-bold uppercase tracking-wide text-indigo-600 dark:text-indigo-300">{snack.category}</p>
                    <h3 className="mt-1 text-base font-extrabold text-gray-900 dark:text-white">{snack.name}</h3>
                  </div>
                  <span className="rounded-full bg-gray-100 px-2.5 py-1 text-xs font-bold text-gray-700 dark:bg-gray-700 dark:text-gray-200">
                    {snack.serving}
                  </span>
                </div>
                <p className="mt-3 flex-1 text-sm leading-6 text-gray-500 dark:text-gray-400">{snack.description}</p>
                <div className="mt-4 grid grid-cols-5 gap-2">
                  <NutritionFact label="Protein" value={snack.protein} />
                  <NutritionFact label="Calories" value={snack.calories} />
                  <NutritionFact label="Carbs" value={snack.carbs} />
                  <NutritionFact label="Fat" value={snack.fat} />
                  <NutritionFact label="Sugar" value={snack.sugar} />
                </div>
                <a
                  href={makeAmazonSearchUrl(snack.query)}
                  target="_blank"
                  rel="noopener noreferrer sponsored"
                  className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-gray-900 px-4 py-2.5 text-sm font-bold text-white hover:bg-gray-800 dark:bg-white dark:text-gray-900 dark:hover:bg-gray-100"
                >
                  Shop on Amazon
                  <ExternalLink className="h-4 w-4" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default MacroSnacks;
